<template>
  <!-- 角色选择区域 -->
  <div class="rolelist" @contextmenu.prevent style="">
    <TabRow
      ref="roleCenter"
      @change="ModelCheck"
      :user.sync="user"
      :t9render="t9render"
      :isH5="isH5"
      :isshow="true"
    ></TabRow>
  </div>
</template>

<script>
import { T9Video } from '@/components/video/t9video.js'
import { localData, asyncLoadJs, validate, getRole } from '@/components/util/util_fun.js'
import { UserCommon } from '@/components/other/UserCommon.js'
export default {
  name: 'SetRole',
  data () {
    return {
      user: null,
      t9render,
      isH5: false,//是否为手机模式，屏幕宽度<600就默认使用手机模式
      t9video: null,

      beforeName: ''
    }

  },
  components: {
    TabRow: () => import(/*webpackChunkName:"Role"*/'@/views/setup/TabRow.vue'),
  },
  created () {
    var exp = validate()
    if (exp == '') {
      this.$store.commit('logout', {})
      //   location.href = '/vup/#/login'
      this.$router.replace('/login')
      return
    };
    if (this.user == null) {
      // debugger
      this.user = localData("get", "historyHodel_" + this.$store.state.userinfo.userId)
      if (this.user == null) {
        this.user = UserCommon.default
      }
      // console.log("试试",this.user);
    }
    if (this.user == null || this.user == '') {
      this.user = getRole(this.$route.params.user)
    }
    this.t9Init()

  },
  // beforeRouteEnter (to, from, next) {
  //console.log(from)
  //   next(vm => {
  //     vm.beforeName = from.name
  //   })


  // },
  methods: {
    t9Init () {

      // let tts = localData("get", "videoobj-new")
      // // console.log('ttsis', tts)
      // if (tts) {
      //   this.t9video = new T9Video(tts)
      // }
      // else {
      //   this.t9video = new T9Video()
      //   // 如果没有资源，增加一个
      //   // console.log('没有资源respush')
      //   localData("set", "historyHodel_" + this.$store.state.userinfo.userId, this.user)
      //   this.t9video.respush(this.user, 1)

      //   // this.t9video.videoobj.scenes[0].scene.gradient = 'background:radial-gradient(circle,#3b424a, #171c1c 67%)'

      // }
      // 如果restype为1,返回索引
      // let roleIndex = this.t9video.scenes[0].res.findIndex((item) => item.restype == 1)
      // // console.log('当前角色的索引', roleIndex)
      // if (roleIndex != -1) {
      //   var tl = this.videoobj.scenes[0].res[roleIndex]
      //   if (tl) {
      //     //无论时间线中的人物是谁，都改成当前角色
      //     tl.resid = this.user.rolesId
      //     tl.resimg = this.user.rolesPhoto//资源封面
      //     tl.resname = this.user.rolesName//资源名称
      //     tl.resobj = this.user
      //   }
      // }
      // localData("set", "videoobj-new", this.videoobj)
      // console.log('初始化完成', this.videoobj)
    },
    /************************这里是切换角色的操作*************************** */
    /**
     * 切换模型
     * @param {*} user 要更换的模型
     * @param {*} reload 是否跳转页面
     *
     */
    ModelCheck (user, reload = true) {
      // console.log("切换模型t9render", user, reload)
      this.user = user
      // return
      // let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
      // if (roleIndex != -1) {
      //   var tl = this.t9video.videoobj.scenes[0].res[roleIndex]
      //   if (tl) {
      //     //无论时间线中的人物是谁，都改成当前角色
      //     tl.resid = this.user.rolesId
      //     tl.resimg = this.user.rolesPhoto//资源封面
      //     tl.resname = this.user.rolesName//资源名称
      //     tl.resobj = this.user
      //   }
      // } else {
      //   this.t9video.videoobj.scenes[0].res.push({
      //     resid: this.user.rolesId,
      //     resname: this.user.rolesName,
      //     resobj: this.user,
      //     restype: 1,
      //     startend: [0, 0],
      //     timeline: []
      //   })
      // }
      // // localData("set", "videoobj-new", this.t9video.videoobj)


      //将模型存入历史中
      localData("set", "historyHodel_" + this.$store.state.userinfo.userId, user)
      // console.log('切换模型', user)
      //切换路由后，也打开了场景，这个地方重复打开了
      let { lastRoute } = localData('get', 'lastRoute')
      if (this.user.isHad && reload) {//持有
        // console.log('name', this.beforeName)
        if (lastRoute == null || lastRoute == '') {
          lastRoute = 'PersonLive'
        }
        if (lastRoute != 'AiLive') {
          lastRoute = 'PersonLive'
        }
        // console.log('user', user)
        //打开控制器
        this.$router.push({
          //   path: '/personlive',
          name: lastRoute,
          params: {
            "user": this.user,
          }
        })
      }
      else {
        //提示协议
        this.$refs.roleCenter.showAdds()

      }

    },
  },
}
</script>

<style lang="scss" scoped>
.rolelist {
  width: initial;
  padding-top: 20px;
  padding-left: 80px;
  overflow-y: auto;
  margin: 0px auto;
}
.model {
  position: relative !important;
}
</style>